import styles from './ContactPage.module.scss'
import React, { ReactElement } from 'react'
import { ContactPageProps } from '@/components/ContactPage/ContactPage.types'
import { MailOutlined, PhoneOutlined } from '@ant-design/icons'
import { reusableCssClass } from '@/utils/reusableCssClasses'
import { CONTACT_PHONE_NUMBER_STRING } from '@/utils/constants'

export const ContactPage: React.FC<ContactPageProps> = (): ReactElement => {
    return (
        <div className={styles.contactUsPage}>
            <div className={styles.contactUsHeader}>CONTACT US</div>
            <div className={styles.contactUsText}>
                We are here to make your actuarial study experience as efficient
                as possible. Please reach out with any questions or concerns and
                we will respond within 2 business days.
            </div>
            <div className={styles.contactUsSubheader}>
                <div>
                    <a
                        href={'mailto:support@justenoughprep.com'}
                        target={'_blank'}
                        className={reusableCssClass.clickableText}
                        rel={'noreferrer'}
                    >
                        <MailOutlined />
                    </a>{' '}
                    support@justenoughprep.com
                </div>
                <div>
                    <PhoneOutlined /> {CONTACT_PHONE_NUMBER_STRING}
                </div>
            </div>
        </div>
    )
}
